import axios from "axios";
//const jipvioApiBase = process.env.JIPVIO_API_BASE;
const baseUriPropSrv = `${process.env.VUE_APP_BASE_URL}/jipviomain/api/v1/property`;
//const baseUriPropSrv = `http://localhost:9083/jipviomain/api/v1/property`;
export default {
  removeUserLikeProperty(propId) {
    return axios({
      method: "delete",
      url: `${baseUriPropSrv}/like/${propId}`,
      validateStatus: () => true,
      timeout: 6000
    })
      .then(res => {
        return {
          status: res.status,
          payload: res.data.payload,
          message: res.data.message,
          detail: res.data.detail
        };
      })
      .catch(err => {
        console.error(err);
        return {
          status: 500,
          message: "서버통신 오류",
          detail: {
            code: -1,
            message: "서버통신 오류"
          }
        };
      });
  },
  saveUserLikeProperty(propId) {
    return axios({
      method: "post",
      url: `${baseUriPropSrv}/like/${propId}`,
      validateStatus: () => true,
      timeout: 6000
    })
      .then(res => {
        return {
          status: res.status,
          payload: res.data.payload,
          message: res.data.message,
          detail: res.data.detail
        };
      })
      .catch(err => {
        console.error(err);
        return {
          status: 500,
          message: "서버통신 오류",
          detail: {
            code: -1,
            message: "서버통신 오류"
          }
        };
      });
  },
  getAllPropertyLike(pagingInfo) {
    return axios({
      method: "get",
      url: `${baseUriPropSrv}/like`,
      params: {
        pageNo: pagingInfo.pageNo,
        sizePerPage: pagingInfo.sizePerPage
      },
      validateStatus: () => true,
      timeout: 6000
    })
      .then(res => {
        return {
          status: res.status,
          payload: res.data.payload,
          pagingInfo: res.data.pagingInfo,
          message: res.data.message,
          detail: res.data.detail
        };
      })
      .catch(err => {
        console.error(err);
        return {
          status: 500,
          message: "서버통신 오류",
          detail: {
            code: -1,
            message: "서버통신 오류"
          }
        };
      });
  },
  getPropertyDetail(propId) {
    return axios({
      method: "get",
      url: `${baseUriPropSrv}/${propId}`,
      validateStatus: () => true,
      timeout: 6000
    })
      .then(res => {
        return {
          status: res.status,
          payload: res.data.payload,
          pagingInfo: res.data.pagingInfo,
          message: res.data.message,
          detail: res.data.detail
        };
      })
      .catch(err => {
        console.error(err);
        return {
          status: 500,
          message: "서버통신 오류",
          detail: {
            code: -1,
            message: "서버통신 오류"
          }
        };
      });
  },

  getPropertyMgmt(GbInfo) {
    return axios({
      method: "get",
      url: `${baseUriPropSrv}/mgmt`,
      params: {
        pageNo: GbInfo.pageNo,
        propType: GbInfo.propType,
        sizePerPage: GbInfo.sizePerPage,
        state: GbInfo.state,
        userType: GbInfo.userType
      },
      validateStatus: () => true,
      timeout: 6000
    })
      .then(res => {
        return {
          status: res.status,
          payload: res.data.payload,
          pagingInfo: res.data.pagingInfo,
          message: res.data.message,
          detail: res.data.detail
        };
      })
      .catch(err => {
        console.error(err);
        return {
          status: 500,
          message: "서버통신 오류",
          detail: {
            code: -1,
            message: "서버통신 오류"
          }
        };
      });
  },

  getAllProperty(pagingInfo) {
    return axios({
      method: "get",
      url: baseUriPropSrv,
      params: {
        pageNo: pagingInfo.pageNo,
        sizePerPage: pagingInfo.sizePerPage,
        swLat: pagingInfo.swLat,
        swLng: pagingInfo.swLng,
        neLat: pagingInfo.neLat,
        neLng: pagingInfo.neLng,
        typeList: pagingInfo.typeList,
        paymentTypeList: pagingInfo.paymentTypeList,
        depositFrom: pagingInfo.depositFrom,
        depositTo: pagingInfo.depositTo,
        parkingYn: pagingInfo.parkingYn,
        roomCntList: pagingInfo.roomCntList,
        orderByProperties: pagingInfo.orderByProperties
      },
      validateStatus: () => true,
      timeout: 6000
    })
      .then(res => {
        return {
          status: res.status,
          payload: res.data.payload,
          pagingInfo: res.data.pagingInfo,
          message: res.data.message,
          detail: res.data.detail
        };
      })
      .catch(err => {
        console.error(err);
        return {
          status: 500,
          message: "서버통신 오류",
          detail: {
            code: -1,
            message: "서버통신 오류"
          }
        };
      });
  },
  saveProperty(propertyInfo) {
    return axios({
      method: "post",
      url: baseUriPropSrv,
      data: propertyInfo,
      validateStatus: () => true,
      timeout: 6000
    })
      .then(res => {
        return {
          status: res.status,
          payload: res.data.payload,
          message: res.data.message,
          detail: res.data.detail
        };
      })
      .catch(err => {
        console.error(err);
        return {
          status: 500,
          message: "서버통신 오류",
          detail: {
            code: -1,
            message: "서버통신 오류"
          }
        };
      });
  }
};
